<template>
  <div class="animated fadeIn">
    <b-row class="top-buffer">
      <b-col md="12">
        <b-button type="button" variant="primary" @click="createReserveModal = true"><i class="fa fa-plus"></i>&nbsp;Create reserve</b-button>
      </b-col>
    </b-row>
    <CreateReserve v-if="createReserveModal" @hidden="createReserveModal = false" @created="createdReserve"></CreateReserve>
    <EditReserve v-if="editReserveModal" @hidden="editReserveModal = false" @edited="editedReserve" @error="editReserveError" :reserveID="editReserve.id"></EditReserve>
    <br>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Reserve Search</strong>
          </div>
          <b-form @submit.prevent="searchReserves()">
            <b-form-group
              label="Check-in Date"
              label-class="font-weight-bold">
              <div style="display: flex; flex-wrap: wrap;">
                <!-- <label class="col-sm-1 col-form-label" style="text-align: center">From</label> -->
                <div>
                  <v-date-picker
                    mode='single'
                    v-model='startDateBegin'
                    :input-props='{class:"form-control", readonly: true }'>
                    <b-form-group
                      slot-scope='{ inputValue, updateValue }'>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-input-group-text>From</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          data-lpignore=true
                          placeholder='-∞' 
                          autocomplete="off"
                          :value='inputValue'
                          @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'></b-form-input>
                        <!-- Attach Right button -->
                        <b-input-group-append>
                          <b-button variant="primary" style="z-index: auto" :disabled="!startDateBegin" @click='startDateBegin = null'>Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </v-date-picker>
                </div>
                <div class="visible-md" style="width: 20px"></div>
                <!-- <label class="col-sm-1 col-form-label"  style="text-align: center">To</label> -->
                <div>
                  <v-date-picker
                    mode='single'
                    v-model='startDateEnd'
                    :input-props='{class:"form-control"}'
                    :min-date='startDateBegin'>
                    <b-form-group
                      slot-scope='{ inputValue, updateValue }'>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-input-group-text>To</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          data-lpignore=true
                          placeholder='+∞' 
                          autocomplete="off"
                          :value='inputValue'
                          @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'></b-form-input>
                        <!-- Attach Right button -->
                        <b-input-group-append>
                          <b-button variant="primary" style="z-index: auto" :disabled="!startDateEnd" @click='startDateEnd = null'>Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </v-date-picker>
                </div>
              </div>
            </b-form-group>
            <b-form-group
              label="Check-out Date"
              label-class="font-weight-bold">
              <div style="display: flex; flex-wrap: wrap;">
                <!-- <label class="col-sm-1 col-form-label" style="text-align: center">From</label> -->
                <div>
                  <v-date-picker
                    mode='single'
                    v-model='stopDateBegin'
                    :input-props='{class:"form-control"}'
                    :min-date='startDateBegin'>
                    <b-form-group
                      slot-scope='{ inputValue, updateValue }'>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-input-group-text>From</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          data-lpignore=true
                          placeholder='-∞' 
                          autocomplete="off"
                          :value='inputValue'
                          @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'></b-form-input>
                        <!-- Attach Right button -->
                        <b-input-group-append>
                          <b-button variant="primary" style="z-index: auto" :disabled="!stopDateBegin" @click='stopDateBegin = null'>Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </v-date-picker>
                </div>
                <div class="visible-md" style="width: 20px"></div>
                <!-- <label class="col-sm-1 col-form-label"  style="text-align: center">To</label> -->
                <div>
                  <v-date-picker
                    mode='single'
                    v-model='stopDateEnd'
                    :input-props='{class:"form-control"}'
                    :min-date='stopDateBegin'>
                    <b-form-group
                      slot-scope='{ inputValue, updateValue }'>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-input-group-text>To</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          data-lpignore=true
                          placeholder='+∞' 
                          autocomplete="off"
                          :value='inputValue'
                          @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'></b-form-input>
                        <!-- Attach Right button -->
                        <b-input-group-append>
                          <b-button variant="primary" style="z-index: auto" :disabled="!stopDateEnd" @click='stopDateEnd = null'>Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </v-date-picker>
                </div>
              </div>
            </b-form-group>
            <b-form-group
              label="Client"
              :label-cols="1"
              :horizontal="true">
              <multiselect v-model="selectedClient" :options="clients" :max="1" :multiple="true" placeholder="Select one" :custom-label="namePhone" label="name" track-by="id"></multiselect>
            </b-form-group>
            <b-form-group
              label="Apartment"
              :label-cols="1"
              :horizontal="true">
              <multiselect v-model="selectedApartment" :options="apartments" :max="1" :multiple="true" placeholder="Select one" label="name" track-by="id"></multiselect>
            </b-form-group>
            <b-form-group
              label="Room"
              :label-cols="1"
              :horizontal="true">
              <multiselect v-model="selectedRoom" :options="rooms" :max="1" :multiple="true" placeholder="Select one" label="number" track-by="id" :disabled="isDisabled"></multiselect>
            </b-form-group>
            <b-form-checkbox id="enabled-checkbox" v-model="enabled.state" :value="true" :unchecked-value="false" :indeterminate.sync="enabled.indeterminate" @input="enabledChange" style="margin-bottom: 1rem">
              Enabled
            </b-form-checkbox>
            <div slot="footer">
              <transition name="fade">
                <b-alert show variant="danger" style="width: 100%;" v-if="error">{{error.message}}</b-alert>
              </transition>
              <b-button type="submit" size="sm" variant="primary" class="btn btn-primary ladda-button" id="search-button" data-style="expand-right"><i class="fa fa-search"></i> Search</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    
    <transition name="fade">
      <b-row v-if="$store.state.reservesSearched.length > 0">
        <b-col md="12">
          <b-card>
            <div slot="header">
              <i class="icon-book-open"></i>
              <strong> Reserves</strong>
            </div>
            <v-client-table name="searchedReservesDatatable" :columns="columns" :data="$store.state.reservesSearched" :options="options" :theme="theme" id="dataTable" v-if="$store.state.reservesSearched.length > 0" @row-click="onRowClick">
            </v-client-table>
          </b-card>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import api from "../../api";
import config from '../../config'
import store from "../../store";
import router from "../../router";
// import cTable from './ClientTable.vue'
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import * as Ladda from "ladda";
import CreateReserve from './CreateReserve.vue'
import EditReserve from './EditReserve.vue'
// import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
// import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
// import format from 'date-fns/format'

import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";

import Multiselect from 'vue-multiselect'

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr

import moment from 'moment'

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

miniToastr.setIcon("success", "i", { class: "fa fa-check-circle-o" });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options);

Vue.use(ClientTable);

// Vue.use(AirbnbStyleDatepicker, datepickerOptions)

// const datepickerOptions = {}

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['DD/MM/YYYY'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD']
  }
});

function compareDate(a, b, key, ascending) {
  let dateA = moment(a[key], "DD-MM-YYYY HH:mm:ss").unix()
  let dateB = moment(b[key], "DD-MM-YYYY HH:mm:ss").unix()

  if (ascending) return dateA >= dateB ? 1 : -1
  return dateA <= dateB ? 1 : -1
}

export default {
  name: "reservesSearch",
  components: {
    ClientTable,
    Event,
    Multiselect,
    // AirbnbStyleDatepicker,
    // datepickerOptions
    CreateReserve,
    EditReserve
  },
  data() {
    return {
      client: {
        // form input fields
        name: null,
        email: null,
        phone: null
      },
      searchButton: null,
      error: null,
      createReserveModal: false,
      editReserveModal: false,
      editReserve: {
        id: null
      },
      columns: ["id","clientName","apartmentName","roomNumber","startDate","stopDate"],
      options: {
        headings: {
          id: "ID",
          clientName: "Client",
          apartmentName: "Apartment",
          roomNumber: "Room",
          startDate: "Check-in",
          stopDate: "Check-out"
        },
        templates: {
          isAdmin: function(h, row, index) {
            if (row.isAdmin) return <i class="fa fa-check" />;
            return "";
          },
          startDate: function(h, row, index) {
            if (row.checkin) return <span>{row.startDate} - <i class="fa fa-check" /></span>
            else return row.startDate
          },
          stopDate: function(h, row, index) {
            if (row.checkin) return <span>{row.stopDate} - <i class="fa fa-check" /></span>
            else return row.stopDate
          }
        },
        sortable: ["id","clientName","apartmentname","roomNumber","startDate","stopDate"],
        customSorting: {
          startDate: function(ascending) {
            return function(a, b) {
              return compareDate(a, b, "startDate", ascending)
            }
          },
          stopDate: function(ascending) {
            return function(a, b) {
              return compareDate(a, b, "stopDate", ascending)
            }
          }
        },
        filterable: ["id","clientName","apartmentName","roomNumber","startDate","stopDate"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: "fixed"
        }
      },
      useVuex: true,
      theme: "bootstrap4",
      template: "default",
      startDateBegin: null,
      startDateEnd: null,
      stopDateBegin: null,
      stopDateEnd: null,
      clients: [],
      selectedClient: [],
      apartments: [],
      selectedApartment: [],
      rooms: [],
      selectedRoom: [],
      enabled: {
        state: true,
        indeterminate: false,
        step: 1
      }
    };
  },
  created: function() {
    if (store.state.clientsSearchFields) this.client = store.state.clientsSearchFields
    this.getClients()
    this.getApartments()
  },
  mounted: function() {
    this.searchButton = Ladda.create(document.querySelector("#search-button"));
  },
  computed: {
    isDisabled() {
      if (this.selectedApartment.length) return false
      else return true
    }
  },
  watch: {
    selectedApartment: function(selected) {
      if (selected.length) this.getRooms(selected[0].id)
      else {
        this.rooms = []
        this.selectedRoom = []
      }
    }
  },
  methods: {
    searchReserves: function() {
      this.error = null
      this.searchButton.start();
      api.request("get", config.serverURI + 'reserves', null, this.searchParams())
        .then(response => {
          store.commit("RESERVES_SEARCH", response.data);
          this.searchButton.stop();
          if (response.data.length === 0) {
            this.error = {
              message: "No reserves match the search parameters!"
            };
          }
        })
        .catch(error => {
          store.commit("RESERVES_SEARCH", [], this.client);
          this.searchButton.stop();
          if (error.response) {
            this.error = {
              message: error.response.data
            };
          } else {
            this.error = {
              message: "Server error!"
            };
          }
        });
    },
    getClients() {
      api.request("get", config.serverURI + 'clients')
        .then(response => {
          this.clients = response.data
        })
        .catch(error => {
          // TODO handle error
          console.log(error)
        })
    },
    getApartments() {
      api.request("get", config.serverURI + 'apartments')
        .then(response => {
          this.apartments = response.data
          if (this.apartments.length === 1) {
            this.selectedApartment = []
            this.selectedApartment.push(this.apartments[0])
          }
        })
        .catch(error => {
          // TODO handle error
          console.log(error)
        })
    },
    getRooms(apartmentID=null) {
      api.request("get", config.serverURI + 'rooms', null, {apartmentID: apartmentID})
        .then(response => {
          this.rooms = response.data
          if (this.rooms.length === 1) {
            this.selectedRoom = []
            this.selectedRoom.push(this.rooms[0])
          }
        })
        .catch(error => {
          // TODO handle error
          console.log(error)
        })
    },
    onRowClick: function(event) {
      this.editReserve.id = event.row.id;
      // this.editClient.name = event.row.name;
      this.editReserveModal = true;
      // console.log(event.row)
      // router.push('client/' + event.row.id)
    },
    createdReserve: function(reserve) {
      miniToastr.success(
        "Reserve was created successfully",
        "Reserve created!"
      );
      this.searchReserves()
    },
    editedClient: function(client) {
      miniToastr.success(
        "Client " + client.name + " was edited successfully",
        "Client edited!"
      );
      this.searchClients(); //force client list update
    },
    editedReserve: function(client) {
      miniToastr.success(
        "Reserve " + this.editReserve.id + " was edited successfully",
        "Reserve edited!"
      );
      this.searchReserves(); //force reserve list update
    },
    editReserveError: function(event) {
      miniToastr.warn("Unable to edit reserve " + this.editReserve.id);
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    nameEmail: function(client) {
      return '' + client.name + ' - ' + client.email
    },
    namePhone: function(client) {
      return '' + client.name + ' - ' + client.phone
    },
    formatDate(date) {
      if (date) return `${moment(date).format("DD-MM-YYYY HH:mm:ss")}`
      else return null
    },
    enabledChange: function(event) {
      console.log(event)
      console.log(this.enabled.state + ' ' + this.enabled.indeterminate)
      switch (this.enabled.step) {
        case 1:
          this.$nextTick(() => {  
            this.enabled = {
              state: false,
              indeterminate: false,
              step: 2
            }
          })
          break
        case 2:
          this.$nextTick(() => {  
            this.enabled = {
              state: false,
              indeterminate: true,
              step: 3
            }
          })
          break
        case 3:
          this.$nextTick(() => {  
            this.enabled = {
              state: true,
              indeterminate: false,
              step: 1
            }
          })
          break
        default:
          break
      }
    },
    searchParams: function() {
      let params = {
        startDateBegin: this.formatDate(this.startDateBegin),
        startDateEnd: this.formatDate(this.startDateEnd),
        stopDateBegin: this.formatDate(this.stopDateBegin),
        stopDateEnd: this.formatDate(this.stopDateEnd),
        clientID: (!this.selectedClient.length) ? null : this.selectedClient[0].id,
        roomID: (!this.selectedRoom.length) ? null : this.selectedRoom[0].id
      }
      if (!this.enabled.indeterminate) {
        params.enabled = this.enabled.state
      }
      return params
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.8s ease;
}
.fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  /* transform: translateX(10px); */
  opacity: 0;
}
</style>

<style lang="scss">
#dataTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>